import { Draft } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';

export const clearStripeFlow = (state: Draft<IPaymentState>) => {
  state.couponCode = null;
  state.updatedAt = Date.now();
  state.paymentIntentClientSecret = null;
  state.setupIntent = null;
  state.paymentMethod = 'card';
};
